import { CollectedItemDetails, MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItem } from "@ponder-shared/tools/filter/filtered-preview-item";
import { FilterType, PreviewItemFilterOption } from "@ponder-shared/tools/filter/preview-item-filter-option";
import { isBlack, isBlue, isColorless, isGreen, isMulticolor, isRed, isWhite, MagicColorFlag } from "../magicCardUtils";

export class MagicCardFilterColor extends PreviewItemFilterOption {
    
    public options: MagicColorFilterOptions = {
        white: { enabled: true, count: 0 },
        blue: { enabled: true, count: 0 },
        black: { enabled: true, count: 0 },
        red: { enabled: true, count: 0 },
        green: { enabled: true, count: 0 },
        multicolor: { enabled: true, count: 0},
        colorless: { enabled: true, count: 0 },
        or: true
    };
    
    private all: boolean = true;
    private mask: number = MagicColorFlag.All;
    
    constructor() {
        super("Color", FilterType.MagicColorIdentity, "", "", "");
    }

    public prepare(): void {
        // ... nothing ...
    }

    public track(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): void {
        this.getMatchingOptions(magicCard).forEach(o => {
            o.count++;
        });
    }

    private getMatchingOptions(magicCard: MagicCard): MagicColorFilterOption[] {
        var options: MagicColorFilterOption[] = [];

        if (isBlack(magicCard)) { options.push(this.options.black); }
        if (isWhite(magicCard)) { options.push(this.options.white); }
        if (isRed(magicCard)) { options.push(this.options.red); }
        if (isGreen(magicCard)) { options.push(this.options.green); }
        if (isBlue(magicCard)) { options.push(this.options.blue); }
        if (isMulticolor(magicCard)) { options.push(this.options.multicolor); }
        if (isColorless(magicCard)) { options.push(this.options.colorless); }

        return options;
    }


    public updateSelection(selection: string, page: string): boolean {
        this.setStoredFilter(selection, page);
        return true;
    }

    public updateColorSelection(white: boolean, blue: boolean, black: boolean, red: boolean, green: boolean, multicolor: boolean, colorless: boolean, or: boolean, page: string): void {
        var newMask = this.getBitMask(white, blue, black, red, green, colorless);

        if ((this.mask == newMask) && (this.options.multicolor.enabled == multicolor) && (this.options.or == or)) {
            return;
        }

        this.options.white.enabled = white;
        this.options.blue.enabled = blue;
        this.options.black.enabled = black;
        this.options.red.enabled = red;
        this.options.green.enabled = green;
        this.options.multicolor.enabled = multicolor;
        this.options.colorless.enabled = colorless;
        this.options.or = or;

        this.all = white && blue && black && red && green && colorless;
        this.mask = newMask;
        this.wasUpdated = true;

        this.setStoredFilter(JSON.stringify(this.options), page);
    }

    public getFilters(): Map<string, number | undefined> {
        // ... nothing ...
        return new Map<string, number | undefined>();
    }

    public isValid(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): boolean {
        if (this.all && this.options.or) {
            return true;
        }

        var cardBitMask = (isColorless(magicCard) ? MagicColorFlag.Colorless : magicCard.colorMask);
        var isValid = false;

        if (this.options.or) {
            isValid = ((cardBitMask | this.mask) == this.mask);
        } else {
            isValid = (cardBitMask == this.mask);
        }

        if (!isValid && this.options.multicolor.enabled) {
            isValid = isMulticolor(magicCard) ?? false;
        }

        return isValid;
    }

    private getBitMask(w: boolean | undefined, u: boolean | undefined, b: boolean | undefined, r: boolean | undefined, g: boolean | undefined, c: boolean | undefined): number {
        return (w ? MagicColorFlag.White : 0) + 
               (u ? MagicColorFlag.Blue : 0) + 
               (b ? MagicColorFlag.Black : 0) + 
               (r ? MagicColorFlag.Red : 0) + 
               (g ? MagicColorFlag.Green : 0) + 
               (c ? MagicColorFlag.Colorless : 0);
    }

    public sort(previewItems: FilteredPreviewItem[]): void {
        // ... nothing ...
    }

    public override setUserInfo(isCollection: boolean, isAuthed: boolean): void {
        // ... nothing ...
    }
}

export type MagicColorFilterOptions = {
    white: MagicColorFilterOption;
    blue: MagicColorFilterOption;
    black: MagicColorFilterOption;
    red: MagicColorFilterOption;
    green: MagicColorFilterOption;
    multicolor: MagicColorFilterOption;
    colorless: MagicColorFilterOption;
    or: boolean;
};

export type MagicColorFilterOption = {
    enabled: boolean;
    count: number;
};